<template>
  <div class="sidebar">

    <div class="banner mb-3">
      <img src="@/assets/banner/acb.png">
    </div>

    <div class="stock_title">Top 10 cổ phiếu</div>
    <div class="stock_chart">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th class="text-center">Mã CK</th>
            <th class="text-right" width="25%">Giá trị</th>
            <th class="text-right" width="25%">Giá</th>
            <th class="text-right" width="30%">Thay đổi</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td class="text-center"><a class="title-link" href="#">SSI</a></td>
            <td class="text-right">960,011</td>
            <td class="text-right txt-green">32,950</td>
            <td class="text-right txt-green">1,300 (4.11%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">VND</a></td>
            <td class="text-right">599,559</td>
            <td class="text-right txt-green">20,900</td>
            <td class="text-right txt-green">1,350 (6.91%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">STB</a></td>
            <td class="text-right">589,946</td>
            <td class="text-right txt-green">30,950</td>
            <td class="text-right txt-green">1,050 (3.51%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">VIX</a></td>
            <td class="text-right">576,541</td>
            <td class="text-right txt-green">15,150</td>
            <td class="text-right txt-green">950 (6.69%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">HPG</a></td>
            <td class="text-right">565,206</td>
            <td class="text-right txt-green">24,950</td>
            <td class="text-right txt-green">50 (0.2%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">DIG</a></td>
            <td class="text-right">477,965</td>
            <td class="text-right txt-green">22,300</td>
            <td class="text-right txt-green">500 (2.29%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">VIC</a></td>
            <td class="text-right">449,103</td>
            <td class="text-right txt-green">45,950</td>
            <td class="text-right txt-green">350 (0.77%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">GEX</a></td>
            <td class="text-right">403,110</td>
            <td class="text-right txt-green">20,350</td>
            <td class="text-right txt-green">550 (2.78%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">DGC</a></td>
            <td class="text-right">379,494</td>
            <td class="text-right txt-green">95,000</td>
            <td class="text-right txt-green">2,000 (2.15%)</td>
          </tr>
          <tr>
            <td class="text-center"><a class="title-link" href="#">NVL</a></td>
            <td class="text-right">338,092</td>
            <td class="text-right txt-green">13,900</td>
            <td class="text-right txt-green">100 (0.72%)</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="banner my-2">
      <img src="@/assets/banner/mbb1.jpg">
    </div>

    <div class="stock_title mt-3">Tỷ giá</div>
    <div class="stock_chart">
      <table class="table table-list-com table-sm table-hover mb-0">
        <thead>
          <tr>
            <th>Mã NT</th>
            <th class="text-right" width="25%">Mua tiền mặt</th>
            <th class="text-right" width="25%">Mua chuyển khoản</th>
            <th class="text-right" width="25%">Bán</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left"><img src="@/assets/theme/flag-us.svg" /> USD</td>
            <td class="text-right">24,235</td>
            <td class="text-right">24,235</td>
            <td class="text-right">24,535</td>
          </tr>
          <tr>
            <td class="text-left"><img src="@/assets/theme/flag_en.svg" /> GBP</td>
            <td class="text-right">29,056</td>
            <td class="text-right">29,231</td>
            <td class="text-right">30,126</td>
          </tr>
          <tr>
            <td class="text-left"><img src="@/assets/theme/hkflag.png" /> HKD</td>
            <td class="text-right">3,049</td>
            <td class="text-right">3,070</td>
            <td class="text-right">3,158</td>
          </tr>
          <tr>
            <td class="text-left"><img src="@/assets/theme/thuysy.png" /> CHF</td>
            <td class="text-right">26,101</td>
            <td class="text-right">26,259</td>
            <td class="text-right">27,076</td>
          </tr>
          <tr>
            <td class="text-left"><img src="@/assets/theme/japan.png" /> JPY</td>
            <td class="text-right">160.5</td>
            <td class="text-right">161.47</td>
            <td class="text-right">168.82</td>
          </tr>
          <tr>
            <td class="text-left"><img src="@/assets/theme/flag-au.svg" /> AUD</td>
            <td class="text-right">15,198</td>
            <td class="text-right">15,290</td>
            <td class="text-right">15,727</td>
          </tr>
          <tr>
            <td class="text-left"><img src="@/assets/theme/canada.png" /> CAD</td>
            <td class="text-right">17,403</td>
            <td class="text-right">17,508</td>
            <td class="text-right">18,036</td>
          </tr>
          <tr>
            <td class="text-left"><img src="@/assets/theme/eurEUR.png" /> EUR</td>
            <td class="text-right">25,218</td>
            <td class="text-right">25,287</td>
            <td class="text-right">26,406</td>
          </tr>
        </tbody>
      </table>
      <div class="text-right">
        <small class="te text-secondary">Cập nhật ngày {{ date }}</small>
      </div>
    </div>

    <div class="banner my-2">
      <img src="@/assets/banner/mbb2.jpg">
    </div>
    <div class="banner my-2">
      <img src="@/assets/banner/mbb3.jpg">
    </div>
  </div>
</template>
<script>
import moment from '@/moment'

export default {
  name: 'Sidebar',
  data() {
    return {
      date: moment().format("DD/MM/YYYY")
    }
  }
}
</script>
<style lang="scss" scoped>
.sidebar {
  .banner {
    img {
      width: 100%;
    }
  }

  .stock_title {
    font-size: 110%;
    font-weight: bold;
    color: #545b66;
  }

  .stock_chart {
    table {

      thead {
        background-color: #E1F5FE;

        tr {
          th {
            padding: 4px 0;
            font-size: 80%;
            text-align: center;
            color: #015096;
            border-color: #01579B;
          }
        }
      }

      tbody {
        tr {
          td {
            padding: 2px 4px;
            font-size: 80%;
            vertical-align: middle;

            .badge {
              border-radius: 8px;
              font-size: 75%;
              padding: 2px 8px;
              color: #FFFFFF;
            }
          }

          td:first-child {
            text-align: left;
            font-size: 90%;
          }
        }
      }
    }

    .table-list-com {
      tbody {
        tr {
          td {
            padding: 4px 2px;

            img {
              width: 21px;
              height: 15px;
              margin-right: 5px;
            }
          }
        }

        tr:nth-child(even) {
          background-color: #E1F5FE;
        }
      }
    }
  }
}
</style>
